<template>
    <div class="w-full overflow-x-auto">
        <table v-loading="loading" class="w-full border border-gray-300 border-collapse min-w-[800px]">
            <thead>
                <tr class="border-b border-gray-300">
                    <th class="px-4 py-2 text-left">Consolidation ID</th>
                    <th class="px-4 py-2 text-left">Consolidation</th>
                    <th class="px-4 py-2 text-left">Shipment Count</th>
                    <th class="px-4 py-2"></th>
                </tr>
            </thead>
            <tbody>
                <tr class="border-b border-gray-300" v-for="consolidation in createdConsolidations" :key="consolidation.id">
                    <td class="px-4 py-2.5">{{ consolidation?.consolidationId }}</td>
                    <td class="px-4 py-2.5">{{ consolidation?.consolidation || 'N/A' }}</td>
                    <td class="px-4 py-2.5">{{ consolidation?.shipmentCount || 'N/A' }} shipment(s)</td>
                    <td class="px-4 py-2"><button class=" text-primary-green"
                            @click="$router.push(`/operations/manifest-new/${consolidation.consolidationDbId}`)">View Manifest</button>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class=" flex justify-end mt-5">
            <base-button text="Confirm" @click="showSuccessConsolidation = true" />
        </div>
        <ConsolidationSuccess :showModal="showSuccessConsolidation" @close-modal="showSuccessConsolidation = false" />
    </div>
</template>

<script>
import ConsolidationSuccess from "../modal/confirm-consolidation.vue"
export default {
    data() {
        return {
            showSuccessConsolidation: false,
            consolidations: [],
            loading: false
        }
    },
    components: {
        ConsolidationSuccess
    },
    computed: {
        currentLocation() {
            return this.$store.getters.currentLocation;
        },
        createdConsolidations() {
            return this.$store?.getters?.getNewCreatedConsolidation?.consolidations
        }
    },
}
</script>

<style lang="scss" scoped></style>